import { render, staticRenderFns } from "./xid-link.vue?vue&type=template&id=16ea0662&scoped=true&"
import script from "./xid-link.vue?vue&type=script&lang=js&"
export * from "./xid-link.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ea0662",
  null
  
)

export default component.exports